import { TermsAndConditions } from '../../../component/auth/legal/terms-and-conditions'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

export const TermsAndConditionsScreen = (): React.ReactElement => {
  return (
    <Container>
      <Row>
        <Col>
          <TermsAndConditions />
        </Col>
      </Row>
    </Container>
  )
}
